import useTracking from './use-tracking';

export { default as usePageTracking } from './use-page-tracking';
export { sendToTrackingEventReceiver } from './lib/tracking-event-receiver';

export default useTracking;
